import React from 'react';
import * as Styled from '../../styled';
import _ from 'lodash';
import { Input } from '@mlc/web-ui-toolkit';
import { AccountFilterElements } from '../AccountFilterElements';

interface Props {
	postcode: string;
	formikProps: any;
}

const PostcodeFilter = (props: Props) => {
	const { handleChange } = props.formikProps;
	return (
		<React.Fragment>
			<Styled.SingleSubCol col="12">
				<Styled.BottomFilterLabel label="Postcode">
					<Input
						name="postcode"
						placeholder="Any"
						onChange={handleChange}
						value={props.postcode}
						data-id={AccountFilterElements.postcodeFilterId}
					/>
				</Styled.BottomFilterLabel>
			</Styled.SingleSubCol>
		</React.Fragment>
	);
};

export default PostcodeFilter;
